import { useLayoutEffect, type RefObject } from 'react';

/**
 * Grow *field* to fit its text whenever *value* changes or its container
 * resizes (a phone rotating, the header reflowing), so a long or multi-line
 * prompt is shown whole for review and editing instead of scrolling inside
 * one row. The reader's search boxes hide overflow and disable manual resize.
 */
export function useAutoResizeTextarea(field: RefObject<HTMLTextAreaElement | null>, value: string): void {
  useLayoutEffect(() => {
    const element = field.current;
    if (!element) return undefined;
    const resize = () => {
      element.style.height = 'auto';
      element.style.height = `${element.scrollHeight}px`;
    };
    resize();
    const observer = new ResizeObserver(resize);
    observer.observe(element.parentElement!);
    return () => observer.disconnect();
  }, [field, value]);
}
